import { Component, OnInit, ViewChild, HostListener, OnDestroy } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { InboxService } from './inbox.service';
import { Reply, List, File } from './inbox.interface';
import { initializeEditor } from 'src/app/utils/editorConfig';
import Swal from 'sweetalert2';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/services/dialog.service';
import { finalize, map, Subscription } from 'rxjs';
import { SabloaneComponent } from './sabloane/sabloane.component';
import { RedirectDialogComponent } from './redirect-dialog/redirect-dialog.component';
import { AppFilesService } from 'src/app/services/app-files.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AddEmailsBlacklistComponent } from 'src/app/platform/nomenclatoare/emails-blacklist/add-emails-blacklist/add-emails-blacklist.component';
import { helper } from 'src/environments/helper';
import { EmailsBlacklistService } from 'src/app/platform/nomenclatoare/emails-blacklist/emails-blacklist.service';
import { environment } from 'src/environments/environment';
import { DashboardService } from '../dashboard-documente/dashboard.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DocIntrareComponent } from '../dashboard-documente/doc-intrare/doc-intrare.component';
import { GeneralData, StoreDocResponse } from '../dashboard-documente/document.interface';
import { GeneralService } from 'src/app/platform/nomenclatoare/general/general.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { CommonService } from 'src/app/services/common.service';
import { ActionHistoryDialogComponent } from './action-history-dialog/action-history-dialog.component';

@Component({
    selector: 'app-inbox',
    templateUrl: './inbox.component.html',
    styleUrls: ['./inbox.component.scss']
})
export class InboxComponent implements OnInit, OnDestroy {
    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;

    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    showTopButtons = true;
    isResizing = false;
    inboxListWidth = 40;

    helper = helper;

    isLoading = false;
    uploading = false;
    uploadedFiles: File[] = [];

    generalData: GeneralData[] = [];
    registreActiveSwitch: Generic[] = [];
    selectedRegistreActiveSwitch: number = -1;

    showCard = false;
    emails: any[] = [];
    selectedEmail: any = null;
    inboxEmailAddress = '';
    totalEmails = 0;
    totalPages = 1;
    totalSeenEmails = 0;
    currentInboxSection: 'received' | 'sent' | 'favorite' = 'received';
    pageInputValue: number | null = null;

    selectedEmails: any[] = [];
    selectedEmailsForGenerate: any[] = [];
    selectedAttachments: any[] = [];

    // Reply
    replyBody = '';
    editorConfig!: AngularEditorConfig;

    // Date range
    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(2025, 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    private contentSubscription!: Subscription;
    expandedHistoryMessages: Set<number> = new Set();

    seenParameters: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Citite', value: 1 },
        { key: 'Necitite', value: 0 },
    ];

    redirectParameters: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Redirecționate', value: 1 },
        { key: 'Neredirecționate', value: 0 },
    ];

    replyParameters: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Răspuns trimis', value: 1 },
        { key: 'Răspuns netrimis', value: 0 },
    ];

    registeredParameters: { key: string; value: number }[] = [
        { key: '-- Alegeți --', value: -1 },
        { key: 'Înregistrate', value: 1 },
        { key: 'Neînregistrate', value: 0 },
    ];

    searchParamsForm!: FormGroup;

    initialFormValues = {
        seen_status: -1,
        redirect_status: -1,
        reply_status: -1,
        registered_status: -1,
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            seen_status: new FormControl(-1),
            redirect_status: new FormControl(-1),
            reply_status: new FormControl(-1),
            registered_status: new FormControl(-1),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT();
    }

    // Opțiuni pentru items per page
    perPageOptions = [10, 20, 50, 100];

    // Payload pentru listă
    listPayload: List = {
        pagination: {
            currentPage: 1,
            perPage: 20
        },
        filters: {
            date_from: this.formatDate(this.selectedStartDate),
            date_to: this.formatDate(this._selectedEndDate),
            redirect_status: -1,
            registered_status: -1,
            reply_status: -1,
            search: '',
            seen_status: -1,
            type: 'received'
        }
    };

    constructor(
        private inboxService: InboxService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private appFilesService: AppFilesService,
        private emailsBlacklistService: EmailsBlacklistService,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
        private toastr: ToastrService,
        private sanitizer: DomSanitizer,
        private generalService: GeneralService,
        public permissionsService: PermissionsService,
    ) { }

    getSafeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        this.loadEmails();
        this.subscribeToContent();

        this.loadGeneralData();
        this.loadActiveSwitch();
    }

    ngOnDestroy(): void {
        if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
        }
    }

    loadEmails(selectEmail: boolean = false) {
        this.isLoading = true;

        this.listPayload.filters.seen_status = this.searchParamsForm.get('seen_status')?.value;
        this.listPayload.filters.redirect_status = this.searchParamsForm.get('redirect_status')?.value;
        this.listPayload.filters.reply_status = this.searchParamsForm.get('reply_status')?.value;
        this.listPayload.filters.registered_status = this.searchParamsForm.get('registered_status')?.value;

        this.inboxService.list(this.listPayload).subscribe({
            next: (response: any) => {
                if (response && response.data) {
                    const data = response.data;
                    this.emails = data.records || [];

                    if (!selectEmail) {
                        this.selectedEmail = null;
                        this.selectedEmails = [];
                        this.selectedEmailsForGenerate = [];
                        this.emails.forEach(email => email.selected = false);
                    }

                    this.totalEmails = data.filtered_records_count || 0;
                    this.totalPages = data.total_pages || 1;
                    this.totalSeenEmails = data.filtered_seen_records_count || 0;
                    this.inboxEmailAddress = data.inbox_email_address || '';
                }
                this.isLoading = false;
            },
            error: (err) => {
                console.error('Error loading emails:', err);
                this.isLoading = false;
            }
        });
    }
    selectEmail(email: any) {
        this.isLoading = true;
        this.replyBody = '';

        this.inboxService.find(email.id).subscribe({
            next: (response: any) => {
                if (response && response.data) {
                    this.selectedEmail = response.data;

                    this.selectedAttachments = [];
                    if (this.selectedEmail.attachments) {
                        this.selectedEmail.attachments.forEach((attachment: any) => {
                            attachment.selected = false;
                        });
                    }
                }
                this.isLoading = false;
            },
            error: (err) => {
                console.error('Error loading email details:', err);
                this.isLoading = false;
            }
        });
    }

    toggleFavorite(email: any, event: Event) {
        event.stopPropagation();

        this.isLoading = true;

        this.inboxService.favorite(email.id).subscribe({
            next: () => {
                this.loadEmails();
                this.isLoading = false;
            },
            error: (err) => {
                console.error('Error favorite:', err);
                this.isLoading = false;
            }
        });
    }

    onPerPageChange(value: number) {
        this.listPayload.pagination.perPage = value;
        this.listPayload.pagination.currentPage = 1;
        this.loadEmails();
    }

    goToPage(page: number) {
        if (page < 1 || page > this.totalPages) return;
        this.listPayload.pagination.currentPage = page;
        this.loadEmails();
    }

    goToFirstPage() {
        this.goToPage(1);
    }

    goToPreviousPage() {
        this.goToPage(this.listPayload.pagination.currentPage - 1);
    }

    goToNextPage() {
        this.goToPage(this.listPayload.pagination.currentPage + 1);
    }

    goToLastPage() {
        this.goToPage(this.totalPages);
    }

    getPageNumbers(): number[] {
        const current = this.listPayload.pagination.currentPage;
        const total = this.totalPages;
        const pages: number[] = [];

        let start = Math.max(1, current - 2);
        let end = Math.min(total, current + 2);

        if (current <= 3) {
            end = Math.min(5, total);
        }
        if (current >= total - 2) {
            start = Math.max(1, total - 4);
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    }

    formatDate(date: Date): string {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    onReply() {
        if (!this.selectedEmail || !this.replyBody) return;

        const replyPayload: Reply = {
            from_email: this.selectedEmail.from_email,
            from_name: this.selectedEmail.from_name,
            cc: this.selectedEmail.to_cc || '',
            subject: this.selectedEmail.subject,
            body: this.replyBody,
            email_id: this.selectedEmail.id,
            files: this.uploadedFiles,
        };

        this.isLoading = true;

        this.inboxService.reply(replyPayload).subscribe({
            next: (response) => {
                console.log('Reply sent successfully', response);
                this.replyBody = '';
                this.uploadedFiles = [];

                const fileInput = document.getElementById('upload-file-input-0') as HTMLInputElement;
                if (fileInput) {
                    fileInput.value = '';
                }

                this.isLoading = false;
                this.selectEmail(this.selectedEmail);
            },
            error: (err) => {
                console.error('Error sending reply:', err);
                this.isLoading = false;
            }
        });
    }

    onTemplates() {
        const dialogRef = this.dialog.open(SabloaneComponent, {
            minHeight: '40vh',
            maxHeight: '100vh',
            minWidth: '50vw',
            maxWidth: '50vw',
            disableClose: true,
        });

        dialogRef
            .afterClosed()
            .subscribe(({ success }: { success: boolean }) => { });
    }

    onForward() {
        let dialogRef = this.dialog.open(RedirectDialogComponent, {
            ...this.dialogService.getDialogConfigMD(),
            data: this.selectedEmail
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: 'Succes!',
                    text: 'Email redirecționat cu succes.',
                    icon: 'success',
                    confirmButtonText: 'Închide',
                }).then(() => {
                    this.selectEmail(this.selectedEmail);
                });
            }
        });
    }

    onDelete(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.inboxService.delete(id).subscribe({
                    next: () => {
                        this.rerenderDT();
                        Swal.fire({
                            title: this.helper.swalTextConfig.headers.deleted,
                            text: 'Email șters cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }

    onSearch(searchTerm: string) {
        this.listPayload.filters.search = searchTerm;
        this.listPayload.pagination.currentPage = 1;
        this.loadEmails();
    }

    switchInboxSection(section: 'received' | 'sent' | 'favorite') {
        this.currentInboxSection = section;
        this.listPayload.filters.type = section;
        this.listPayload.pagination.currentPage = 1;
        this.selectedEmail = null;
        this.loadEmails();
    }

    onRefresh() {
        this.loadEmails();
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    onPreluareEmail() {
        if (!this.selectedEmail) return;

        this.isLoading = true;
        this.inboxService.preluare(this.selectedEmail.id).subscribe({
            next: () => {
                this.selectEmail(this.selectedEmail);
                this.loadEmails(true);
            },
            error: (err) => {
                console.error('Error marking as taken:', err);
                this.isLoading = false;
            }
        });
    }

    onNepreluareEmail() {
        if (!this.selectedEmail) return;

        this.isLoading = true;
        this.inboxService.nepreluare(this.selectedEmail.id).subscribe({
            next: () => {
                this.selectEmail(this.selectedEmail);
                this.loadEmails(true);
            },
            error: (err) => {
                console.error('Error marking as not taken:', err);
                this.isLoading = false;
            }
        });
    }

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);

        this.selectedEndDate = new Date(this.today);
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);

        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = yearsBack === 0 ? this.today : new Date(year, 11, 31);
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    rerenderDT(): void {
        this.listPayload.filters.date_from = this.formatDate(this.selectedStartDate);
        this.listPayload.filters.date_to = this.formatDate(this.selectedEndDate);
        this.listPayload.pagination.currentPage = 1;
        this.loadEmails();
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    openEditDialog(value: string, type: number) {
        let dialogRef = this.dialog.open(EditDialogComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                value,
                type,
                emailId: this.selectedEmail.id
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: 'Succes!',
                    text: 'Email actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: 'Închide',
                }).then(() => {
                    this.selectEmail(this.selectedEmail);
                });
            }
        });
    }

    subscribeToContent() {
        this.contentSubscription = this.inboxService.sablonContent$.subscribe({
            next: (content) => {
                this.replyBody = content;
            },
        });
    }

    loadGeneralData(): void {
        this.isLoading = true;
        this.generalService
            .list()
            .pipe(
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (response: any) => {
                    this.generalData = response.data;
                },
                error: (error) => {
                    console.error('Error loading data:', error);
                    this.isLoading = false;
                }
            });
    }

    loadActiveSwitch() {
        this.isLoading = true;
        this.commonService
            .getActiveSwitch()
            .pipe(
                map((resp: Generic[]) => [{ name: '-- Serie --', id: -1 }, ...resp]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.registreActiveSwitch = results;
                    if (this.registreActiveSwitch.length > 1) {
                        this.selectedRegistreActiveSwitch = this.registreActiveSwitch[1].id;
                    }
                },
                error: (error) => {
                    console.error('Error loading serii active', error);
                },
            });
    }


    downloadAttachment(attachment: any) {
        let fullPath = this.inboxService.downloadUrl + attachment.id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    toggleHistoryMessage(messageId: number) {
        if (this.expandedHistoryMessages.has(messageId)) {
            this.expandedHistoryMessages.delete(messageId);
        } else {
            this.expandedHistoryMessages.add(messageId);
        }
    }

    isHistoryMessageExpanded(messageId: number): boolean {
        return this.expandedHistoryMessages.has(messageId);
    }

    addToBlacklist(email: string) {
        const dialogRef = this.dialog.open(AddEmailsBlacklistComponent, {
            ...this.dialogService.getDialogConfig(),
            data: { email: email }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.selectEmail(this.selectedEmail);

                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adăugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    removeFromBlacklist(id: number) {
        Swal.fire({
            title: helper.swalTextConfig.commonTitles.areYouSure,
            text: helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.emailsBlacklistService.deleteEntry(id).subscribe({
                    next: () => {
                        this.selectEmail(this.selectedEmail);
                        Swal.fire({
                            title: helper.swalTextConfig.headers.deleted,
                            text: 'Înregistrare ștearsă cu succes.',
                            icon: 'success',
                            confirmButtonText: helper.swalTextConfig.buttonLabels.ok,
                        });
                    },
                    error: (err: any) => {
                        Swal.fire({
                            title: helper.dialogConfig.headers.errorAtentie,
                            text: err.error.errors.message[0],
                            icon: 'error',
                            confirmButtonText: helper.dialogConfig.buttonLabels.close,
                        })
                    }
                });
            }
        });
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Verifică dacă fișierul există deja în lista de fișiere încărcate
            const fileExists = this.uploadedFiles.some(
                uploadedFile => uploadedFile.original_name === file.name
            );

            if (fileExists) {
                this.openToast({
                    title: 'Atenție',
                    message: `Fișierul "${file.name}" este deja încărcat.`,
                    type: 'warning',
                });
                continue; // Sari peste acest fișier și continuă cu următorul
            }

            this.uploading = true;

            const formData = new FormData();
            formData.append('file', file, file.name);

            this.dashboardService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== 'undefined' ? result : result.error;
                    if (typeof response.status_code !== 'undefined') {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== 'undefined'
                        ) {
                            // Adaugă fișierul în array-ul simplu
                            this.uploadedFiles.push(result.data);

                            this.uploading = false;

                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }


    downloadFile(uploadedFile: File) {
        const fullPath = this.dashboardService.tempFileDownloadUrl;
        const payload = {
            fileName: uploadedFile.filename,
            originalName: uploadedFile.original_name,
        }
        this.isLoading = true;
        this.appFilesService.postDownloadFile(fullPath, payload)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    removeFile(index: number) {
        if (index > -1 && index < this.uploadedFiles.length) {
            this.uploadedFiles.splice(index, 1);

            // Resetează input-ul pentru a permite reîncărcarea fișierelor șterse
            const fileInput = document.getElementById('upload-file-input-0') as HTMLInputElement;
            if (fileInput) {
                fileInput.value = '';
            }
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    downloadHistoryAttachment(attachment: any, event: Event) {
        // Previne expandarea/colapsarea mesajului când dai click pe buton
        event.stopPropagation();

        let fullPath = this.inboxService.downloadUrl + attachment.id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            });
    }

    getPlainTextPreview(html: string, maxLength: number = 100): string {
        if (!html) return '';

        // Elimină tag-urile HTML
        const tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        const text = tmp.textContent || tmp.innerText || '';

        // Curăță spațiile multiple și newline-urile
        const cleanText = text.replace(/\s+/g, ' ').trim();

        // Returnează preview-ul trunChiat
        if (cleanText.length > maxLength) {
            return cleanText.substring(0, maxLength) + '...';
        }

        return cleanText;
    }

    onEmailCheckboxChange(email: any) {
        if (email.selected) {
            if (!this.selectedEmails.find(e => e.id === email.id)) {
                this.selectedEmails.push(email);
            }
            const eligibleForGenerate = email.assigned_user_id
                && email.type === 'received'
                && !email.doc_intrare;
            if (eligibleForGenerate && !this.selectedEmailsForGenerate.find(e => e.id === email.id)) {
                this.selectedEmailsForGenerate.push(email);
            }
        } else {
            this.selectedEmails = this.selectedEmails.filter(e => e.id !== email.id);
            this.selectedEmailsForGenerate = this.selectedEmailsForGenerate.filter(e => e.id !== email.id);
        }
    }


    onGenerateDocument() {
        const dialogRef = this.dialog.open(DocIntrareComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            panelClass: 'full-screen-dialog-100',
            data: {
                generalData: this.generalData,
                serieId: this.selectedRegistreActiveSwitch,
                inboxEmailsData: this.selectedEmailsForGenerate
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse }) => {
            this.onRefresh();
            if (success) {
                this.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    onAttachmentCheckboxChange(attachment: any) {
        if (attachment.selected) {
            // Adaugă atașamentul în array-ul de selectate
            if (!this.selectedAttachments.find(a => a.id === attachment.id)) {
                this.selectedAttachments.push(attachment);
            }
        } else {
            // Șterge atașamentul din array-ul de selectate
            this.selectedAttachments = this.selectedAttachments.filter(a => a.id !== attachment.id);
        }
    }

    onGenerateDocumentWithAttachments() {
        const dialogRef = this.dialog.open(DocIntrareComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            panelClass: 'full-screen-dialog-100',
            data: {
                generalData: this.generalData,
                serieId: this.selectedRegistreActiveSwitch,
                inboxAttachementsData: {
                    selectedEmail: this.selectedEmail,
                    selectedAttachments: this.selectedAttachments
                }
            },
        });
        dialogRef.afterClosed().subscribe(({ success, resData }: { success: boolean, resData: StoreDocResponse }) => {
            this.onRefresh();
            if (success) {
                this.openToast({
                    title: this.helper.dialogConfig.headers.success,
                    message: `Documentul înregistrat cu succes cu numărul ${resData.reg_number} - ${resData.reg_date}`,
                    type: this.helper.dialogConfig.icons.success,
                });
            }
        });
    }

    print(id: number) {
        let fullPath = this.inboxService.printUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Print error: ', err);
                this.isLoading = false;
            })
    }

    printFile(id: number) {
        let fullPath = this.inboxService.printFileUrl + id;
        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Print error: ', err);
                this.isLoading = false;
            })
    }

    toggleTopButtons() {
        this.showTopButtons = !this.showTopButtons;
    }

    openDocument(id: number) {
        const url = `#/documente?id=${id}`;
        window.open(url, '_blank');
    }

    processFile(id: number) {
        if (!this.selectedEmail) return;

        this.isLoading = true;
        this.inboxService.processFile(id).subscribe({
            next: () => {
                this.selectEmail(this.selectedEmail);
                this.loadEmails(true);
            },
            error: (err) => {
                console.error('Error process file: ', err);
                this.isLoading = false;
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            }
        });
    }

    processFileAll(id: number) {
        if (!this.selectedEmail) return;

        this.isLoading = true;
        this.inboxService.processFileAll(id).subscribe({
            next: () => {
                this.selectEmail(this.selectedEmail);
                this.loadEmails(true);
            },
            error: (err) => {
                console.error('Error process all files: ', err);
                this.isLoading = false;
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            }
        });
    }

    hasUnprocessedAttachments(): boolean {
        if (!this.selectedEmail || !this.selectedEmail.attachments || this.selectedEmail.attachments.length === 0) {
            return false;
        }

        return this.selectedEmail.attachments.some((attachment: any) => attachment.processed_server === false);
    }

    goToSpecificPage() {
        if (this.pageInputValue && this.pageInputValue >= 1 && this.pageInputValue <= this.totalPages) {
            this.goToPage(this.pageInputValue);
            this.pageInputValue = null; // Reset input după navigare
        } else if (this.pageInputValue) {
            // Notificare pentru pagină invalidă
            this.openToast({
                title: 'Atenție',
                message: `Pagina trebuie să fie între 1 și ${this.totalPages}`,
                type: 'warning',
            });
            this.pageInputValue = null;
        }
    }

    onPageInputKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.goToSpecificPage();
        }
    }

    onMouseDown(event: MouseEvent) {
        this.isResizing = true;
        event.preventDefault();
    }

    onPrintEmails() {
        if (!this.selectedEmails || this.selectedEmails.length === 0) return;

        const ids = this.selectedEmails.map(e => e.id);
        const fullPath = this.inboxService.printEmailsUrl;

        this.isLoading = true;
        this.appFilesService.postDownloadFile(fullPath, { ids })
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Print emails error: ', err);
                this.isLoading = false;
            });
    }

    onPrintEmailThread() {
        if (!this.selectedEmail) return;

        const fullPath = this.inboxService.printEmailThreadUrl + this.selectedEmail.id + '/export';

        this.isLoading = true;
        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Print thread error: ', err);
                this.isLoading = false;
            });
    }

    onOpenActionHistory(): void {
        if (!this.selectedEmail) return;

        this.dialog.open(ActionHistoryDialogComponent, {
            minWidth: '520px',
            maxWidth: '640px',
            maxHeight: '85vh',
            data: {
                subject: this.selectedEmail.subject,
                action_history: this.selectedEmail.action_history || []
            }
        });
    }

    @HostListener('document:mousemove', ['$event'])
    onMouseMove(event: MouseEvent) {
        if (!this.isResizing) return;

        const container = document.querySelector('.inbox-container') as HTMLElement;
        if (!container) return;

        const containerRect = container.getBoundingClientRect();
        const newWidth = ((event.clientX - containerRect.left) / containerRect.width) * 100;

        // Limitează între 25% și 75%
        if (newWidth >= 25 && newWidth <= 75) {
            this.inboxListWidth = newWidth;
        }
    }

    @HostListener('document:mouseup')
    onMouseUp() {
        this.isResizing = false;
    }
}